export const MESES = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

export const fmtMoney = (n) =>
  new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS', maximumFractionDigits: 0 }).format(Number(n || 0));

export const fmtNum = (n) => new Intl.NumberFormat('es-AR').format(Number(n || 0));

export const fmtMoneyShort = (v) => {
  const n = Number(v || 0);
  if (Math.abs(n) >= 1e9) return `$${(n / 1e9).toFixed(1)}B`;
  if (Math.abs(n) >= 1e6) return `$${(n / 1e6).toFixed(1)}M`;
  if (Math.abs(n) >= 1e3) return `$${(n / 1e3).toFixed(0)}k`;
  return `$${n}`;
};

export const fmtNumShort = (v) => {
  const n = Number(v || 0);
  if (Math.abs(n) >= 1e6) return `${(n / 1e6).toFixed(1)}M`;
  if (Math.abs(n) >= 1e3) return `${(n / 1e3).toFixed(1)}k`;
  return `${n}`;
};

export const fmtPeriodo = (p, shortYear = false) => {
  if (!p) return '—';
  const [y, m] = p.split('-');
  const yy = shortYear ? y.slice(2) : y;
  return `${MESES[parseInt(m, 10) - 1]} ${yy}`;
};

export const CHART_COLORS = ['#4f46e5', '#0ea5e9', '#10b981', '#3b82f6', '#6366f1', '#0284c7', '#14b8a6', '#8b5cf6'];

// Variación porcentual entre valor actual y previo. Devuelve {pct, dir} o null.
export const calcDelta = (cur, prev) => {
  if (prev === undefined || prev === null || prev === 0) return null;
  const v = ((Number(cur) - Number(prev)) / Math.abs(Number(prev))) * 100;
  return { pct: v, dir: v >= 0 ? 'up' : 'down' };
};

// Período anterior a uno dado (YYYY-MM)
export const prevPeriodo = (p) => {
  if (!p) return null;
  let [y, m] = p.split('-').map(Number);
  m -= 1;
  if (m < 1) { m = 12; y -= 1; }
  return `${y}-${String(m).padStart(2, '0')}`;
};
